import styled from 'styled-components';
import { Button, Tooltip } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, typography, layout } = primitives;

export const PrinterTitle = styled.p`
  font-family: ${typography.family0};
  font-weight: ${typography.weight4};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight3};
  color: ${color.gray7};
  margin-bottom: ${typography.size0};
`;
export const PrinterMainTitle = styled.h2`
  font-family: ${typography.family0};
  font-weight: ${typography.weight4};
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight5};
  color: ${color.black};
  margin: ${layout.size3}px 0px;
`;

export const PrinterDescription = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight2};
  color: ${color.gray7};
  margin-bottom: ${typography.size4};
`;
export const PrinterQuickLink = styled.a`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  align-items: center;
  text-decoration-line: underline;
  color: ${color.electricBlue7};
  margin-bottom: ${typography.size4};
`;
export const PrinterCommitmentDetails = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  color: #666666;
  margin-top: ${typography.size4};
  margin-bottom: 6px;
`;
export const PrinterTotalPermonth = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight4};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight4};
  color: ${color.black};
  margin-bottom: 4px;
`;
export const PrinterPagesPerMonth = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  color: ${color.gray12};
  margin-bottom: ${typography.size4};
  align-self: flex-start;
  display: flex;
  align-items: center;
`;

export const PrinterCurrentPlan = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${layout.size2}px;
  background: ${color.electricBlue0};
  border-radius: ${layout.cornerRadius2}px;
  margin-bottom: ${layout.size6}px;
  padding: ${layout.size2}px;
  color: ${color.black};
  font-size: ${typography.size3}px;
  line-height: ${typography.lineHeight3}px;
  font-weight: ${typography.weight3};
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const PrinterButton = styled(Button)`
  width: 49%;
  height: 48px;
`;
export const PrinterThanksButton = styled(Button)`
  width: 49%;
  height: 48px;
`;
export const CheckmarkText = styled.span`
  margin-left: 4px;
  display: flex;
  gap: 4px;
`;
export const PrinterDivider = styled.hr`
  border: 1px solid #e0e0e0;
`;
export const ImageContainer = styled.div`
  img {
    width: 20px;
    height: 20px;
  }
`;
export const OutOfStockInfoText = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  > svg {
    fill: ${color.orange6};
  }
  > .info__text {
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
    color: ${color.orange11};
  }
`;

export const ToolTipText = styled.div`
  font-size: ${typography.size0};
  line-height: ${typography.lineHeight1};
  font-weight: ${typography.weight3};
  color: ${color.white};
  max-width: 200px;
  white-space: normal;
  word-wrap: break-word;
  padding: ${layout.size1}px;
`;

export const StyledTooltip = styled(Tooltip)`
  vertical-align: sub !important;
  margin-left: 2px !important;
`;
